var _style, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.3 143.1",
    style: {
      enableBackground: "new 0 0 595.3 143.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#C8C9D3;}\r\n\t.st2{fill:#C5CBD4;}\r\n\t.st3{fill:#B5B9C6;}\r\n\t.st4{fill:#6D6D6D;}\r\n\t.st5{fill:#98A2BD;}\r\n\t.st6{fill:#EC1C26;}\r\n\t.st7{fill:#646363;}\r\n\t.st8{fill:#D0D3DF;}\r\n\t.st9{fill:#F6211F;}\r\n\t.st10{fill:#B5B6CC;}\r\n\t.st11{fill:#EC3137;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.6,115.5c22.6,4,90.6,5.7,144.3,6.5l-1.9-2.2l93.1,2.6c41.5-0.4,139.7-1.7,199-5.1 c24-1.4,45.8-4.6,64.5-8.4l-14.7-14.1l49.1,0.8l4,3.8c12-3.6,20.6-6.8,25-8.5c0.3-1.4-0.3-2.7-3.1-3.5c-8-2.3-28.5-6.7-81.9-8.5 c-53.4-1.8-273.2-3.7-282.6-3.7c-9.4-0.1-97.6-0.5-132.5,2.9c0,0-10.9-1.8-37.4,13c0,0-18.4,11.2-19.9,12.4 C5.6,103.5-2.1,109.4,0.6,115.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M537.9,99.3l3.9,3.7c10.8-4,16.3-6.9,16.3-6.9s4.1-2.7,4.8-5.2C558.5,92.6,549.9,95.8,537.9,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M248.5,122.8l9.3,7.7c50.5,0.1,99.8,0.2,103.3,0.2c7.3-0.1,78.1-2.2,125.1-12c6.8-1.4,13.2-2.9,19.1-4.4 l-5.7-5.4c-18.7,3.8-40.5,7-64.5,8.4c-59.3,3.4-157.5,4.7-199,5.1L248.5,122.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M144.9,122c-53.7-0.8-121.7-2.5-144.3-6.5c1.8,4.1,8.4,8.4,25.5,11c42.2,6.5,114.5,4,119.9,3.8 c0.5,0,2.7,0,6.3,0L144.9,122z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M499.5,109l5.7,5.4c15.5-4,27.7-8,36.5-11.3l-3.9-3.7l-4-3.8l-49.1-0.8L499.5,109z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M216.6,122.6c0,0,7.3-0.1,19.5-0.2l-93.1-2.6l1.9,2.2C184.6,122.5,216.6,122.6,216.6,122.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M145,121.9l7.4,8.3c16.3,0,61.3,0.1,105.4,0.2l-9.3-7.7l-12.4-0.3c-12.2,0.2-19.5,0.2-19.5,0.2 S184.6,122.5,145,121.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M541,93.5c-7.3,2.8-11.6,2.6-11.6,2.6s-39.8-0.2-40.6-0.1c-0.8,0-5.7-0.6-5.4-3.6c0.3-3,5.4-3.4,5.4-3.4 s37.5-7.5,58.3-11.8c20.9-4.4,28.2-3.7,28.2-3.7l18.3-0.2C593.6,73.3,548.3,90.7,541,93.5z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M14.2,98.2l4.7,0.2l1.2,2.2c3.6,0.2,9.8-1.3,12.2-2.2c2.4-0.9,2.1-5.5,0.4-5.7S23,92.6,23,92.6L14.2,98.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M76.1,98.9l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C77.3,101.4,76.1,100.3,76.1,98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M88,99l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C89.2,101.5,88,100.4,88,99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M99.5,99.1l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C100.7,101.5,99.5,100.5,99.5,99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M111.3,99.1l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C112.5,101.5,111.3,100.4,111.3,99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M123.3,99l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C124.5,101.5,123.3,100.4,123.3,99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M134.7,99.2l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C135.9,101.6,134.7,100.6,134.7,99.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M146.3,99.2l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C147.5,101.7,146.3,100.6,146.3,99.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M158.2,99.2l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C159.4,101.7,158.2,100.6,158.2,99.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M170,99.2l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C171.2,101.6,170,100.6,170,99.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M181.4,99.4l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C182.6,101.9,181.4,100.8,181.4,99.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M193.2,99.3l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C194.4,101.8,193.2,100.7,193.2,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M205.1,99.5l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C206.3,102,205.1,100.9,205.1,99.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M216.6,99.5l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C217.8,102,216.6,100.9,216.6,99.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M228.6,99.5l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C229.9,102,228.7,100.9,228.6,99.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M239.9,99.5l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C241.2,101.9,240,100.8,239.9,99.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M345.4,99.9l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C346.6,102.3,345.5,101.2,345.4,99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M357.5,99.9l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C358.7,102.4,357.6,101.3,357.5,99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M368.9,100l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C370.1,102.4,369,101.4,368.9,100z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M380.8,100.1l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C382,102.6,380.9,101.5,380.8,100.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M392.3,100.2l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C393.5,102.6,392.4,101.5,392.3,100.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M403.6,100.1l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C404.8,102.5,403.7,101.5,403.6,100.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M415.2,100.2l-0.1-2c-0.1-1.4,1-2.5,2.4-2.6l0,0c1.4-0.1,2.5,1,2.6,2.4l0.1,2c0.1,1.4-1,2.5-2.4,2.6l0,0 C416.4,102.6,415.3,101.6,415.2,100.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M391.2,60.1c-4.4,0.4-7,3-7.5,4.1c-0.5,1-7.9,8.9-14.7,14.5c-6.8,5.6-24,7.4-24,7.4l-195.4,22.6 c0,0-11.4,1.3-11.6,7.8s8.4,8,11,8.2c2.7,0.2,52.5,0.5,52.5,0.5s44.9-0.5,48.3-1s118.6-30.6,118.6-30.6 c26.2-7.4,33.4-34.4,33.4-34.4S395.6,59.7,391.2,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M381.4,87.4c15.6-10.7,20.3-28.3,20.3-28.3s-6.2,0.5-10.6,0.9s-7,3-7.5,4.1c-0.5,1-7.9,8.9-14.7,14.5 c-3.5,3-9.8,4.9-15.1,6L381.4,87.4z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M155.8,140.3c0,0,19.4-1.2,29-2.4c4.4-0.6,7.5-2.1,9.6-4.2c-3.7-6.4-11.9-11.6-20.9-13.2 c-6.6-1.1-11.7-5.3-14.8-8.4c-1.8,0.1-2.9,0.2-2.9,0.2L155.8,140.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M194.2,133.8c2.5-2.5,3.6-5.7,3.5-9c-0.1-6.1-5.7-10.6-14.7-12.3c-6.8-1.3-18.9-0.7-24.4-0.4 c3.1,3.1,8.2,7.3,14.8,8.4C182.4,122.1,190.7,127.3,194.2,133.8z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 153.2,
    y: 110.5,
    transform: "matrix(0.9966 -8.271700e-02 8.271700e-02 0.9966 -9.8924 13.3244)",
    className: "st6",
    width: 5.4,
    height: 31.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.7,
    y: 120.4,
    transform: "matrix(0.9966 -8.271700e-02 8.271700e-02 0.9966 -9.6448 16.8027)",
    className: "st7",
    width: 2.6,
    height: 8.8
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M541.2,83.6c-8.8-2.7-118.6-5.6-118.6-5.6c0.2-0.7,1.4-1.1,1.4-1.1C496.5,69,532,16,536.8,9.7 s15.3-6.4,15.3-6.4L572.2,3L541.2,83.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.16ab1437364b1adbef10b86f8c737d85.svg";
export { ForwardRef as ReactComponent };